/**
 * Team members vuex store
 */

import { feathers } from '@/feathers-client';

export default {

  namespaced: true,

  state: {
    teamMembers: [],
    teamMembersInProgress: false,
    error: null,
  },

  getters: {
    teamMembersInfo(state) {
      const teamMembers = state.teamMembers.map(member => {
        return {
          text: `${member.user.first_name} ${member.user.last_name}`,
          value: member.user.id,
        };
      });
      return teamMembers;
    },
  },

  mutations: {
    setTeamMembers(state, teamMembers) {
      state.teamMembers = teamMembers;
    },
    setTeamMemberError(state, error) {
      state.error = error;
    },
    setTeamMemberInProgress(state, value) {
      state.teamMembersInProgress = value;
    },
  },

  actions: {
    // find team members - users that can own a contact or can be assigned to a contact
    async findTeamMembers({ commit, rootState }, options = {}) {
      try {
        const params = {
          $paginate: false,
          $sort: { 'user.first_name': 1, 'user.last_name': 1 },
          request_status: 'Accepted',
        };
        const query = Object.assign(params, options);
        commit('setTeamMemberInProgress', true);
        let teamMembers = await feathers.service('team-members').find({ query });
        // return the user if no team members are found
        if (!teamMembers.length) {
          const { id, first_name: firstName, last_name: lastName } = rootState.userInformation.user;
          teamMembers = [
            {
              user: {
                id,
                first_name: firstName,
                last_name: lastName,
              },
            },
          ];
        }
        commit('setTeamMembers', teamMembers);
        commit('setTeamMemberInProgress', false);
      } catch (err) {
        commit('setTeamMemberError', err);
        commit('setTeamMemberInProgress', false);
      }
    },
    // find team members only if state is empty 
    async findTeamMembersIfEmpty({ state, dispatch }) {
      if (state.teamMembersInProgress || state.teamMembers.length) return;
      await dispatch('findTeamMembers');
    },
  },

};
